import { render, staticRenderFns } from "./trigger-edit.vue?vue&type=template&id=546afb56&"
import script from "./trigger-edit.vue?vue&type=script&lang=ts&"
export * from "./trigger-edit.vue?vue&type=script&lang=ts&"
import style0 from "./trigger-edit.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports